import styled from "styled-components";
import { Color } from "../../styles/Colors";

export const TableContainer = styled.div`
  width: 100%;
  border: 1px solid #e0e0e0;
  border-radius: 12px;
  overflow-x: auto;
  background: #fff;
`;

export const StyledTable = styled.table`
  width: 100%;
  border-collapse: collapse;
  font-size: 14px;
  color: ${Color.textDark || "#333"};

  thead {
    background: #f7f8fa;
    position: sticky;
    top: 0;
    z-index: 5;
  }
`;

export const Th = styled.th<{ $active?: boolean }>`
  text-align: left;
  padding: 10px 16px;
  height: 44px; /* ✅ controls header row height */
  line-height: 1.4;
  font-weight: 600;
  border-bottom: 1px solid #e0e0e0;
  cursor: pointer;
  user-select: none;
  transition: all 0.2s ease;
  color: ${({ $active }) => ($active ? Color.darkBlue : "#444")};

  &:hover {
    background-color: #f0f3f8;
  }
`;

export const Td = styled.td`
  padding: 12px 16px;
  height: 52px; /* ✅ controls data row height */
  line-height: 1.4;
  vertical-align: middle;
  white-space: nowrap;
`;

export const Tr = styled.tr`
  border-bottom: 1px solid #eee;
  transition: background-color 0.2s ease;

  &:hover {
    background-color: #f9fcff;
    cursor: pointer;
  }
`;

export const IconWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const NoData = styled.div`
  text-align: center;
  padding: 24px;
  color: #777;
`;
